import SearchTerms from './searchTermsResource';

import bids from '../shared/resource/bids';
import transformSearchTermKeywords from './transformers/transformSearchTermKeywords';
import campaignIdAndRangeNormalizer from '@/api/shared/normalizers/campaignIdAndRangeNormalizer';
import errorTransformer from '@/api/shared/transformers/errorTransformer';

function getSearchTerms({ campaignId, range }) {
  return SearchTerms.getSearchTerms(
    campaignIdAndRangeNormalizer(campaignId, range),
  )
    .then(({ body: { data } }) => transformSearchTermKeywords(data))
    .catch(errorTransformer);
}

function addBulkBids(data) {
  return bids.addBulkBids({ ...data, referrer: 'search-terms' });
}

export default { addBulkBids, getSearchTerms };
